import { MyObservation } from 'libs/end-to-end/src/my-observation';
import { LevelDefinition } from 'libs/end-to-end/src/types/databases/dimensions/level-definition';
import { DimensionDefinition } from 'libs/end-to-end/src/types/databases/dimensions/dimension-definition';

export const getAllDimensionsFromObservation = (
  myObservation: MyObservation | null,
) => {
  const dimensionDefinitions = myObservation?.dimensions || [];
  return dimensionDefinitions;
};

export const getAllLevelsFromObservation = (
  myObservation: MyObservation | null,
): LevelDefinition[] => {
  const dimensionDefinitions = getAllDimensionsFromObservation(myObservation);
  const levelDefinitions = dimensionDefinitions.flatMap(
    (dimension) => dimension.levels,
  );
  return levelDefinitions;
};

export const getDimensionByColumnHeaderValueFromObservation = (
  myObservation: MyObservation | null,
  columnHeaderValue: string,
): DimensionDefinition | undefined => {
  const dimensionDefinitions = getAllDimensionsFromObservation(myObservation);
  return dimensionDefinitions.find((d) => {
    return (
      d.columnHeaderValue.toLowerCase() === columnHeaderValue.toLowerCase()
    );
  });
};

export const getLevelByColumnValueFromObservation = (
  myObservation: MyObservation | null,
  columnHeaderValue: string,
  columnValue: string,
): LevelDefinition | undefined => {
  const dimension = getDimensionByColumnHeaderValueFromObservation(
    myObservation,
    columnHeaderValue,
  );
  if (!dimension) {
    return undefined;
  }
  return dimension.levels.find(
    (l) => l.columnValue.toLowerCase() === columnValue.toLowerCase(),
  );
};

export const isMinorityDimensionLevelFromObservation = (
  myObservation: MyObservation | null,
  columnHeaderValue: string,
  columnValue: string,
): boolean => {
  const level = getLevelByColumnValueFromObservation(
    myObservation,
    columnHeaderValue,
    columnValue,
  );
  return level ? !level.isPrivileged : false;
};

export const getAllLevelsForDimensionFromObservation = (
  myObservation: MyObservation | null,
  columnHeaderValue: string,
): LevelDefinition[] => {
  const dimension = getDimensionByColumnHeaderValueFromObservation(
    myObservation,
    columnHeaderValue,
  );
  if (!dimension) {
    return [];
  }
  return dimension.levels;
};

export const getPrivilegedLevelForDimensionFromObservation = (
  myObservation: MyObservation | null,
  columnHeaderValue: string,
): LevelDefinition | undefined => {
  const dimension = getDimensionByColumnHeaderValueFromObservation(
    myObservation,
    columnHeaderValue,
  );
  if (!dimension) {
    return undefined;
  }
  return dimension.levels.find((l) => l.isPrivileged);
};

export const getAllPrivilegedLevelsFromObservation = (
  myObservation: MyObservation | null,
) => {
  const allLevels = getAllLevelsFromObservation(myObservation);
  return allLevels.filter((l) => l.isPrivileged);
};

export const getAllUnprivilegedLevelsFromObservation = (
  myObservation: MyObservation | null,
) => {
  const allLevels = getAllLevelsFromObservation(myObservation);
  return allLevels.filter((l) => !l.isPrivileged);
};

export const getLevelsByColumnValueForDimensionFromObservation = (
  myObservation: MyObservation | null,
  dimension: string,
) => {
  const dimensionInfo = getDimensionByColumnHeaderValueFromObservation(
    myObservation,
    dimension,
  );
  const lvls: Record<string, LevelDefinition> = {};

  if (!dimensionInfo) {
    return lvls;
  }

  for (const level of dimensionInfo.levels) {
    lvls[level.columnValue] = level;
  }

  return lvls;
};
